import classNames from "classnames";
import { useTranslation } from "react-i18next";

import Pill from "../../../common/Pill";
import styles from "./styles.module.scss";

export function ItemAcceptedStatus() {
  const { t } = useTranslation();
  return (
    <Pill
      styleName="accepted"
      Lefticon={<img src={"../../../assets/images/svg/money.svg"} />}>
      <p className={classNames(styles.text, "p2")}>
        {t("lbl_listing_item_accepted_status")}
      </p>
    </Pill>
  );
}
